import * as React from 'react';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import { HeaderButton, IHeaderButtonProps } from '../HeaderButton';

type TDeleteButtonProps = IHeaderButtonProps;

export const DeleteButton = (props: TDeleteButtonProps) => (
  <HeaderButton {...props} dataTestId="DeleteButton">
    <IconActionClose16 color="icon-secondary-default" />
  </HeaderButton>
);
